import { vueCreateAppInit } from '@/utils/js/initVariable';
import FileUploadPopup from '@/components/FileUploadPopup';

/**
 * 在 marker 上绑定文件上传 popup 控制
 * @param {Object} marker - Leaflet marker 实例
 * @param {Object} target - 数据对象（回显用，可包含 id, videoFileName 等）
 */
export function fileUploadControlInit(marker, target) {
  const { lat, lng } = marker.getLatLng();
  // 创建离线 DOM 节点
  const popupMountNode = document.createElement('div');
  const app = vueCreateAppInit(FileUploadPopup, {
    lat,
    lng,
    initialData: target && Object.keys(target).length > 0 ? target : undefined,
  });

  // 立即将 Vue 组件渲染到离线 DOM 中（消除打开弹窗时的延迟）
  app.mount(popupMountNode);

  marker.on({
    remove: () => { app.unmount(); },
  }).bindPopup(popupMountNode, {
    closeButton: false,
    autoClose: false,
    direction: 'top',
    className: 'leaflet-popup-message home-file-popup-message',
  });
}
